exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports
exports.locals = {
	"ingleprimary": "#004687",
	"inglesecondary": "#f07d00",
	"ingleagentprimary": "#7900F0",
	"ingleagentsecondary": "#f2f2f2",
	"rimiprimary": "#3a17c5",
	"rimisecondary": "#3a17c5",
	"msgprimary": "#961a1a",
	"msgsecondary": "#961a1a",
	"visitcanadaprimary": "#3498DB",
	"visitcanadasecondary": "#3498DB",
	"insurecanadaprimary": "#146ab5",
	"insurecanadasecondary": "#146ab5",
	"alumoprimary": "#CD5C5C",
	"alumosecondary": "#CD5C5C"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader?outputStyle=expanded!./src/styles/Colours.scss
// module id = 258
// module chunks = 0